import { BigNumber } from '@ethersproject/bignumber';
import { useQuery } from '@tanstack/react-query';
import { features } from '@ui/components/Features';
import { useVenoSDK } from '@ui/providers/VenoSDKProvider';
import type { VenoSDK } from '@veno-app/sdk';

import { isFeatureEnabled } from './useIsFeatureEnabled';

const getLcroRedeemable = (sdk: VenoSDK, amount?: number) => {
  const amountBn = amount
    ? BigNumber.from(Math.round(10 ** 9 * amount)).mul(10 ** 9)
    : undefined;

  return {
    queryFn: async () =>
      !isFeatureEnabled(features.vvsLpTracking) || !amount
        ? BigNumber.from(0)
        : await sdk.VvsCroLpToken.getLcroRedeemable(amountBn),
    queryKey: ['get-lcro-redeemable', `${amount}`],
  };
};

const useLcroRedeemableAtVVSPool = (amount?: number) => {
  const sdk = useVenoSDK();

  return useQuery(getLcroRedeemable(sdk, amount));
};

export default useLcroRedeemableAtVVSPool;
